import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormFeedback, InputGroupAddon, InputGroupText, InputGroup, CustomInput } from 'reactstrap';
import api from '~/services/api';
import Loader from '~/components/Loader/Loader'

function ModalCreate({ showModal, toggle, loadProducts }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('PLAN');
  const [typeSubscription, setTypeSubscription] = useState('');
  const [gateway, setGateway] = useState('VINDI');
  const [externalId, setExternalId] = useState('');
  const [urlIdentifier, setUrlIdentifier] = useState('');
  const [price, setPrice] = useState('');
  const [possibleInstallments, setPossibleInstallments] = useState('');
  const [recurrence, setRecurrence] = useState('');
  const [allowCoupon, setAllowCoupon] = useState(true)
  const [allowBankSlip, setAllowBankSlip] = useState(true)
  const [allowPix, setAllowPix] = useState(true)
  const [allowCreditCard, setAllowCreditCard] = useState(true)
  const [emptyName, setEmptyName] = useState(false)
  const [emptyDescription, setEmptyDescription] = useState(false)
  const [emptyGateway, setEmptyGateway] = useState(false)
  const [emptyExternalId, setEmptyExternalId] = useState(false)
  const [emptyUrlIdentifier, setEmptyUrlIdentifier] = useState(false)
  const [emptyPrice, setEmptyPrice] = useState(false)
  const [emptyPossibleInstallments, setEmptyPossibleInstallments] = useState(false)
  const [emptyRecurrence, setEmptyRecurrence] = useState(false)
  const [loading, setLoading] = useState(false)
  const [discountValue, setDiscountValue] = useState('')
  const [allowDiscount, setAllowDiscount] = useState(false)
  const [hasShirtSize, setHasShirtSize] = useState(false)
  const [chargeLater, setChargeLater] = useState(false)
  const [chargeLaterDays, setChargeLaterDays] = useState('')

  async function validateProduct() {
    try {
      await api.get(`validateProduct/${type}/${externalId}/${gateway}`)
      return true
    } catch (error) {
      setLoading(false)
      toast.error(`Código externo não encontrado na ${gateway}`);
      return false
    }
  }

  async function handleSubmit() {
    try {
      setLoading(true)

      const data = {
        name: name,
        description: description,
        type: type,
        subscription_type: typeSubscription,
        gateway: gateway,
        external_id: externalId,
        url_identifier: urlIdentifier,
        price: price ? parseFloat(price) : 0,
        possible_installments: possibleInstallments,
        recurrence: parseInt(recurrence),
        allow_coupon: allowCoupon,
        allow_bank_slip: allowBankSlip,
        allow_pix: allowPix,
        allow_credit_card: allowCreditCard,
        apply_discount: allowDiscount,
        discount_value: discountValue,
        has_shirt_size: hasShirtSize,
        charge_later: chargeLater,
        charge_later_days: chargeLater ? parseInt(chargeLaterDays) : 0,
      }

      if (!data.name) setEmptyName(true)
      if (!data.description) setEmptyDescription(true)
      if (!data.gateway) setEmptyGateway(true)
      if (!data.external_id) setEmptyExternalId(true)
      if (!data.url_identifier) setEmptyUrlIdentifier(true)
      if (data.price < 0) setEmptyPrice(true)
      if (!data.possible_installments) setEmptyPossibleInstallments(true)
      if (!data.recurrence) setEmptyRecurrence(true)

      if (
        !data.name ||
        !data.description ||
        !data.gateway ||
        !data.external_id ||
        !data.url_identifier ||
        data.price < 0 ||
        !data.possible_installments ||
        !data.recurrence
      ) {
        setLoading(false)
        return
      }

      const validated = await validateProduct()

      if (!validated) return

      await api.post('products', data)

      setEmptyName(false)
      setEmptyDescription(false)
      setEmptyGateway(false)
      setEmptyExternalId(false)
      setEmptyUrlIdentifier(false)
      setEmptyPrice(false)
      setEmptyPossibleInstallments(false)
      setEmptyRecurrence(false)
      setLoading(false)

      toast.success('Produto cadastrado com sucesso')

      loadProducts(1)
    } catch (error) {
      console.log(error.response.data[0]?.message)
      setLoading(false)

      if (error.response.data?.length > 0 && error.response.data[0]?.message === 'external_id_already_exists') {
        toast.error('Código externo já cadastrado')
      } else if (error.response.data?.length > 0 && error.response.data[0]?.message === 'url_identifier_already_exists') {
        toast.error('Identificador de URL já cadastrado')
      } else {
        toast.error('Ocorreu um erro ao cadastrar o produto')
      }
    }
  }

  return (
    <div>
      <Modal isOpen={showModal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Cadastrar produto</ModalHeader>
        <ModalBody>
          {loading && <Loader />}
          <Form>
            <FormGroup>
              <Label for="name">Nome</Label>
              <Input type="text" name="name" id="name" value={name} onChange={e => setName(e.target.value)} invalid={emptyName} />
              <FormFeedback>Nome é obrigatório</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="description">Descrição</Label>
              <Input type="textarea" name="description" id="description" value={description} onChange={e => setDescription(e.target.value)} invalid={emptyDescription} />
              <FormFeedback>Descrição é obrigatório</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="type">Tipo</Label>
              <Input type="select" name="type" id="type" value={type} onChange={e => setType(e.target.value)}>
                <option value="PLAN">Plano</option>
                <option value="PRODUCT">Produto</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="type">Tipo da Assinatura</Label>
              <Input type="select" name="type" id="type" value={typeSubscription} onChange={e => setTypeSubscription(e.target.value)}>
                <option value=""></option>
                <option value="BASIC">BASIC</option>
                <option value="START">START</option>
                <option value="ESSENTIAL">ESSENTIAL</option>
                <option value="PERSONAL">PERSONAL</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="gateway">Gateway</Label>
              <Input type="text" name="gateway" id="gateway" value={gateway} onChange={e => setGateway(e.target.value.toUpperCase())} invalid={emptyGateway} />
              <FormFeedback>Gateway é obrigatório</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="external_id">Código externo</Label>
              <Input type="text" name="external_id" id="external_id" value={externalId} onChange={e => setExternalId(e.target.value)} invalid={emptyExternalId} />
              <FormFeedback>Código externo é obrigatório</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="url_identifier">Identificador de URL</Label>
              <Input type="text" name="url_identifier" id="url_identifier" value={urlIdentifier} onChange={e => setUrlIdentifier(e.target.value.replace(' ', '-'))} invalid={emptyUrlIdentifier} />
              <FormFeedback>Identificador de URL é obrigatório</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="price">Preço</Label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>R$</InputGroupText>
                </InputGroupAddon>
                <Input type="number" name="price" id="price" price={price} onChange={e => setPrice(e.target.value)} invalid={emptyPrice} />
                <FormFeedback>Preço é obrigatório</FormFeedback>
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <Label for="possible_installments">Parcelamentos possíveis (Separar por vírgula*)</Label>
              <Input type="text" name="possible_installments" id="possible_installments" value={possibleInstallments} onChange={e => setPossibleInstallments(e.target.value.trim())} invalid={emptyPossibleInstallments} />
              <FormFeedback>Parcelamentos possíveis é obrigatório</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="recurrence">Recorrência</Label>
              <Input type="number" name="recurrence" id="recurrence" value={recurrence} onChange={e => setRecurrence(e.target.value)} invalid={emptyRecurrence} />
              <FormFeedback>Recorrência é obrigatório</FormFeedback>
            </FormGroup>
            <FormGroup>
              <CustomInput type="switch" id="allow_coupon" name="allow_coupon" label="Permitir cupom?" checked={allowCoupon} onChange={() => setAllowCoupon(prev => !prev)} />
            </FormGroup>

            <FormGroup>
              <CustomInput type="switch" id="allow_credit_card" name="allow_credit_card" label="Permitir cartão de crédito?" checked={allowCreditCard} onChange={() => setAllowCreditCard(prev => !prev)} />
            </FormGroup>

            <FormGroup>
              <CustomInput type="switch" id="allow_bank_slip" name="allow_bank_slip" label="Permitir boleto?" checked={allowBankSlip} onChange={() => setAllowBankSlip(prev => !prev)} />
            </FormGroup>

            <FormGroup>
              <CustomInput type="switch" id="allow_pix" name="allow_pix" label="Permitir PIX?" checked={allowPix} onChange={() => setAllowPix(prev => !prev)} />
            </FormGroup>

            <FormGroup>
              <CustomInput type="switch" id="allow_discount_pix" name="allow_discount_pix" label="Possui desconto no pix?" checked={allowDiscount} onChange={() => setAllowDiscount(prev => !prev)} />
            </FormGroup>

            <FormGroup>
              <Label for="discountPix">Percentual Desconto PIX</Label>
              <Input type="number" name="discountPix" id="discountPix" value={discountValue} onChange={e => setDiscountValue(e.target.value)} />
            </FormGroup>

            <FormGroup>
              <CustomInput type="switch" id="has_shirt_size" name="has_shirt_size" label="Possui tamanho de camiseta?" checked={hasShirtSize} onChange={() => setHasShirtSize(prev => !prev)} />
            </FormGroup>

            <FormGroup>
              <CustomInput type="switch" id="charge_later" name="charge_later" label="Cobrar depois?" checked={chargeLater} onChange={() => setChargeLater(prev => !prev)} />
            </FormGroup>

            {chargeLater && (
              <FormGroup>
                <Label for="charge_later_days">Dias para cobrar depois</Label>
                <Input type="number" name="charge_later_days" id="charge_later_days" value={chargeLaterDays} onChange={e => setChargeLaterDays(e.target.value)} />
              </FormGroup>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Cancelar</Button>{' '}
          <Button color="primary" onClick={handleSubmit}>Salvar</Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default ModalCreate;